import { render, staticRenderFns } from "./UserTasks.vue?vue&type=template&id=f09ad36a&scoped=true&"
import script from "./UserTasks.vue?vue&type=script&lang=js&"
export * from "./UserTasks.vue?vue&type=script&lang=js&"
import style0 from "./UserTasks.vue?vue&type=style&index=0&id=f09ad36a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09ad36a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAvatar,VBtn,VCard,VCardText,VIcon,VSnackbar})
